module.exports = __webpack_public_path__ + "static/media/banner_1.b76eec0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_1.png
// module id = 1575
// module chunks = 10